import { render, staticRenderFns } from "./DemonstrativeAmountsPaidModal.vue?vue&type=template&id=62281a72"
import script from "./DemonstrativeAmountsPaidModal.vue?vue&type=script&lang=js"
export * from "./DemonstrativeAmountsPaidModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports